import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { TotemService } from '../totem.service';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-pelicula',
  templateUrl: './pelicula.component.html',
  styleUrls: ['./pelicula.component.css']
})
export class PeliculaComponent implements OnInit {
  id;
  datospelicula;
  descripcion;
  horarios;
  horariosordenados;
  datospeli;
  hayhorarios = false;
  horaactual;
  IDCine = environment.codCine;
  constructor(private totemService: TotemService, private route: ActivatedRoute) {
  }

  async ngOnInit() {
    this.getHoraactual();
    this.id = this.route.snapshot.paramMap.get('id');
    this.id = parseInt(this.id, 10);
    const peliculas = await this.totemService.geteventos().subscribe(eventos => {
      for (const peli of eventos) {
        if (peli.eve_id === this.id) {
          this.datospelicula = peli;
          let des;
          des = this.datospelicula.descripcion.replace('<p>', '');
          des = des.replace('</p>', '');
          this.datospelicula.des = des.split('#')[0];
          this.datospeli = JSON.parse(peli.titulo);
          const horarios =  des.split('#').slice(1, -1);
          this.horariosordenados =  this.ordenarHorarios(horarios);
          console.log('arreglo final', this.horariosordenados);
          if (this.horariosordenados.length > 0) {
              this.hayhorarios = true;
          }
        }
      }
    });
  }

  getHoraactual() {
     const fecha = new Date();
     const hora = fecha.getHours().toString();
     let minuto: any = fecha.getMinutes();
     if ( minuto < 10) {
       minuto = '0' + minuto.toString();
     } else {
       minuto = minuto.toString();
     }
     this.horaactual = hora + ':' + minuto;
    //  console.log('pasado', this.horaactual);
  }
  ordenarHorarios(horarios: any) {

    const arreglofinal = [];
    for (const tiempos of horarios) {
      const dia = tiempos.split('_')[0];
      if (dia) {
        const horas = tiempos.split('_')[1].split(' ');
        const tiposrhorarios = [];
        let datohorarios;
        for (const formatos of horas) {
          const lahora = formatos.split('/')[0];
          const eltipo = formatos.split('/')[1];
          const tiposeparado = eltipo.split(',');

          if (tiposrhorarios.indexOf(eltipo) === -1) {
            tiposrhorarios.push(eltipo);
            datohorarios = {
              tipo: eltipo,
              horas: [lahora],
            };
            arreglofinal.push(datohorarios);
          } else {
            const n = tiposrhorarios.indexOf(eltipo);
            if (arreglofinal[n].horas.indexOf(lahora) === -1) {
              arreglofinal[n].horas.push(lahora);
            }
          }
        }
      }
    }

    for (const hor of arreglofinal) {
     hor.horas.sort();
     const tipos = hor.tipo.split(',');
     hor.tipo = tipos;
    }

    return arreglofinal;
  }
}
